// @flow
import {
    GET_TEMPERATURE_HISTORY,
    GET_TEMPERATURE_HISTORY_SUCCESS,
    SELECT_PERIOD,
    SET_TARGET_TEMPERATURE,
    SET_TARGET_TEMPERATURE_SUCCESS,
    SET_TARGET_TEMPERATURE_UPDATE_PRODUCT,
    TOGGLE_READY_BY
} from './constants';

import { createAction } from 'redux-actions';

export const setHeatingTarget = createAction(SET_TARGET_TEMPERATURE);
export const setHeatingTargetUpdateProduct = createAction(SET_TARGET_TEMPERATURE_UPDATE_PRODUCT);
export const setHeatingTargetSuccess = createAction(SET_TARGET_TEMPERATURE_SUCCESS);
export const getTemperatureHistory = createAction(GET_TEMPERATURE_HISTORY);
export const getTemperatureHistorySuccess = createAction(GET_TEMPERATURE_HISTORY_SUCCESS);
export const selectTemperatureHistoryPeriod = createAction(SELECT_PERIOD);
export const toggleReadyBy = createAction(TOGGLE_READY_BY);



// WEBPACK FOOTER //
// ./src/core/state/products/heating/actions.js